<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div class="writehand hand"
      v-show="judge"
      :style="{ 'z-index': modaldata.Zindex, }"
      @mousedown.stop
      @click="close($event)"
    >
      <div class="hand__dialog dialog" ref="dialogRef">
        <div class="dialog__close" ref="closeEl">
          <i class="icon-popup-close"></i>
        </div>
        <div class="dialog__header">
          选择文字手势
        </div>
        <div class="dialog__main">
          <div class="tabs">
            <div class="tabs__panel" v-bar>
              <div>
                <ul>
                  <li @click="cancelSelect()" :class="{'is-active': defHandActive}">
                    <!-- <i class="icon-no-hand"></i> -->
                    <!-- <span>使用默认手势</span> -->
                    <img src="/static/animengine/img/writehand-nail.jpg" alt="">
                  </li>
                  <li
                    v-for="(item, i) in hands"
                    :key="i"
                    :class="{'is-active': item.active}"
                    @click="selectHand(item)"
                  >
                    <img :src="$handleAssetsUrl(item.thumbnailUrl_1)" alt="">
                    <img :src="$handleAssetsUrl(item.url_1)" alt="" style="width: 0; height: 0; opacity: 0;">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import modal    from '../mixins/modal'
import { mapGetters } from 'vuex'
import Velocity from 'velocity-animate'

export default {
  mixins: [modal],
  data () {
    return {
      modalName: 'writehand',
      judgeInner: false,
      hands: [],
      defHandActive: true
    }
  },
  computed: {
    ...mapGetters([
      'SelectSprites_Msg',
      'SelectScenes_Msg',
      'StyleMsg',
      'TOOL'
    ]),
    sprite () {
      return this.SelectSprites_Msg[0];
    }
  },
  watch: {
    // judge (val) {
    //   this.activateItem();
    //   // this.$nextTick(() => {
    //     this.judgeInner = val;
    //   // });
    // }
  },
  async created () {
    let {data: resData} = await this.$http.get('/api/common/material?type=7&sOfPage=24&fPage=255&pIndex=1&fileType=18')
    this.hands = resData.data;
  },
  methods: {
    close (ev) {
      if (this.$refs.closeEl.contains(ev.target)) {
        this.close_();
        return;
      }
      if (ev.target === ev.currentTarget) {
        this.close_();
      }
    },
    close_ () {
      this.$nextTick(() => {
        // this.judge = false;
        this.$set(this._data, 'judge', false);
      })
    },
    selectHand (item) {
      let [armLeft, armTop] = item.nibCoord_1.split(',').map(s => parseFloat(s));
      
      let data = {
        entranceAnim: {
          writehand: {
            url: this.$handleAssetsUrl(item.url_1),
            armLeft,
            armTop,
            resourceId: item.id
          }
        }
      }
      this.SelectSprites_Msg && this.SelectSprites_Msg.map(v => v.updateEffect(data, true))

      this.activateItem();
      this.closeModal();
    },
    activateItem () {
      let { writehand: writehandData } = this.sprite.effect.entranceAnim;
      let isDefaultHand = writehandData == null || writehandData == 'defaults';
      writehandData = writehandData || {}
      if (writehandData.url === this.TOOL.option.assets.writeHand || isDefaultHand) {
        this.hands.map((item) => {
          this.$set(item, 'active', false);
        });
        this.defHandActive = true;
        return;
      }
      this.defHandActive = false;
      this.hands.map((item) => {
        // let url = this.$handleAssetsUrl(item.url_1);
        // let urlRef = this.$handleAssetsUrl((writehandData || {}).url);
        // let shouldActive = url === urlRef
        let id = item.id;
        let idRef = writehandData.resourceId;
        let shouldActive = id === idRef;
        this.$set(item, 'active', shouldActive);
      })
    },
    cancelSelect () {
      // this.sprite
      //   .effect.updateWriteHand('defaults');
      let data = {
        entranceAnim: {
          writehand: null
        }
      }
      this.SelectSprites_Msg && this.SelectSprites_Msg.map(v => v.updateEffect(data, true))

      this.activateItem();
      this.closeModal();
    },
    beforeEnter () {
      const dialog = this.$refs.dialogRef;
      $(dialog).css({
        marginTop: -300,
        opacity: 0
      })
      dialog.style.marginTop = '-300px';
    },
    enter (el, done) {
      const dialog = this.$refs.dialogRef;
      Velocity(dialog, {
        opacity: 1,
        marginTop: '0px',
      }, {
        duration: 300,
        easing: "easeOutSine",
        complete: done
      })
    },
    leave (el, done) {
      const dialog = this.$refs.dialogRef;
      Velocity(dialog, {
        marginTop: 0,
        opacity: 0
      }, {
        duration: 100,
        complete: done
      })
    },
    afterLeave() {
      const dialog = this.$refs.dialogRef;
      this.closeModal();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";
@import "../../style/transition";

.hand {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  &__dialog {
    position: absolute;
    // top: 0;
    // left: 0;
    // bottom: 0;
    // right: 0;
    // margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 680px;
    height: 462px;
    // transform: translatey(-300px);
  }
}

.dialog {
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    height: 34px;
    line-height: 34px;
    padding-right: 13px;
    padding-left: 13px;
    cursor: pointer;
  }
  &__header {
    height: 34px;
    line-height: 34px;
    border-radius: 4px 4px 0 0;
    background-color: $c1;
    text-indent: 18px;
    text-align: left;
  }
  &__main {
    border-radius: 0 0 4px 4px;
    height: 428px;
    background-color: $c0;
    // padding: 30px 0;
    overflow-y: hidden;
  }
}

.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  & > div {
    margin-top: 20px;
  }
}

.tabs {
  &__panel {
    height: 428px;
    & > div {
      // width: (120 * 4 + 44 * 3 + 15) * 1px !important;
      // height: 330px + 17px !important;
      height: calc(100% + 16px) !important;
    }
    & > div > ul {
      display: flex;
      flex-wrap: wrap;
      padding: 30px 38px 0;
      // width: (120 * 4 + 44 * 3) * 1px;
      // margin-left: -4px;
      margin: 4px;
      & > li {
        width: 120px;
        height: 120px;
        margin-bottom: 47px;
        margin-right: 38px;
        box-shadow: 0 0 0 2px #ececfa;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0;
        }

        &.is-active {
          box-shadow: 0 0 0 2px $c2;
        }

        & > img {
          height: 100%;
          text-align: center;
        }

        &:first-of-type {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &>span {
            margin-top: 15px;
            color: $c14;
            cursor: default;
          }
        }
      }
    }
    & > div > .empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      & > div {
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/writehand.vue